import React, { Component, PropTypes } from 'react';
import { Colors } from 'Css';
import FormFieldContainer from './FormFieldContainer';
import AspectRatioContainer from 'components/AspectRatioContainer';
import * as SvgIcons from 'components/Material/SvgIcons';
import UploadDialog from 'components/MediaLibrary/UploadDialog';

const css = oxygenCss({
  imageContainer: {
    textAlign: 'center',
    cursor: 'pointer',
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: '#535353',
    position: 'relative',
    '&hasImage': {
      borderColor: Colors.creen
    }
  },
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const styles = {
  icon: {
    width: 64,
    height: 64
  },
  addIcon: {
    position: 'absolute',
    right: -12,
    bottom: -12
  }
};

class ImageChooser extends Component {
  static propTypes = {
    title: PropTypes.string,
    onChange: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    uploadDialog: false
  };

  openDialog = () => {
    this.setState({ uploadDialog: true });
  };

  closeDialog = () => {
    this.setState({ uploadDialog: false });
  };

  changeImage = src => {
    const { onChange } = this.props;
    onChange && onChange(src);
    this.closeDialog();
  };

  render() {
    const { title } = this.props;
    const { uploadDialog } = this.state;
    const { getIntlMessage } = this.context;
    return (
      <FormFieldContainer title={title}>
        <AspectRatioContainer
          mediaClassName={css.imageContainer}
          onTouchTap={this.openDialog}
        >
          <div className={css.wrapper}>
            <SvgIcons.ImageLandscape style={styles.icon} color={'#535353'} />
            <SvgIcons.ContentAddCircleOutline
              color={Colors.creen}
              style={styles.addIcon}
            />
          </div>
        </AspectRatioContainer>
        <UploadDialog
          onRequestClose={this.closeDialog}
          onSuccess={this.changeImage}
          title={getIntlMessage('image.upload')}
          description={getIntlMessage('module.dropImage')}
          type="image"
          open={uploadDialog}
        />
      </FormFieldContainer>
    );
  }
}

export default ImageChooser;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/ImageChooser.js